import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { amountDarkThemeTwo } from '../../../components/_ThemeTwo_/';

import {
  amountTheme,
  colorAvocado,
  colorBlackberry,
  colorBlackberry05,
  colorBlackberry20,
  colorBlackberry45,
  colorBlackberry60,
  colorBlackberry70,
  colorCoconut,
  colorPomegranate70
} from './amountCommon';
import { defaultDatePicker, IThemeInterface } from './common';

const theme: IThemeInterface = {
  ...amountTheme,
  name: 'amountDark',
  colorBackground: '#01212e',
  outline: `2px solid #2178c0`,

  colorBlack: '#fff',

  colorSlate70: colorBlackberry45,

  alert: {
    ...amountTheme.alert,
    inactive: {
      colorBackground: colorBlackberry,
      colorText: '#fff',
      colorBorder: colorBlackberry,
    }
  },
  actionButton: {
    colorText: '#fff',
    colorTextHover: colorAvocado,
    colorTextActive: colorBlackberry,
    colorBorder: colorBlackberry70,
    colorBorderHover: colorAvocado,
    colorBackgroundActive: '#63c698'
  },
  banner: {
    ...amountTheme.banner,
    inactive: {
      colorLink: '#fff',
      colorBackground: colorBlackberry,
      colorText: '#fff',
      colorBorder: colorBlackberry,
    },
    sectionBackground: colorBlackberry
  },
  bannerSection: {
    colorBackground: colorBlackberry
  },
  button: {
    ...amountTheme.button,
    secondary: {
      ...amountTheme.button.secondary,
      colorBorder: colorCoconut,
      colorBorderHover: colorAvocado,
      colorBorderDisabled: colorBlackberry70,
      colorBackgroundFocus: 'transparent',
      colorBackgroundHover: 'transparent',
      colorText: colorCoconut,
      colorTextHover: colorAvocado,
      colorTextDisabled: colorBlackberry70,
    },
    alert: {
      ...amountTheme.button.alert,
      colorBackgroundHover: 'transparent',
      colorBackgroundFocus: 'transparent',
      colorBorder: colorCoconut,
      colorBorderHover: colorAvocado,
      colorBorderDisabled: colorBlackberry70,
      colorText: colorCoconut,
      colorTextHover: colorAvocado,
      colorTextDisabled: colorBlackberry70,
    }
  },
  brand: {
    ...amountTheme.brand,
    colorSecondary: colorPomegranate70,
    colorAlert: colorPomegranate70,
  },
  card: {
    ...amountTheme.card,
    borderRadius: '0',
    boxShadow: 'none',
    colorBorder: colorBlackberry70,
    colorBackground: colorBlackberry,
  },
  datepicker: {
    ...merge(cloneDeep(defaultDatePicker), {
      weekday: {
        color: 'inherit'
      },
      selection: {
        ...defaultDatePicker.selection,
        color: colorBlackberry,
        backgroundColor: colorBlackberry20,
      }
    })
  },
  header: {
    ...amountTheme.header,
    colorBreadcrumbText: colorBlackberry60,
    colorLink: colorCoconut,
    colorLinkHover: colorCoconut,
    colorSubNavLink: colorCoconut,
    colorSubNavLinkHover: colorCoconut,
  },
  headline: {
    ...amountTheme.headline,
    small: {
      ...amountTheme.headline.small,
      colorText: colorCoconut
    },
    medium: {
      ...amountTheme.headline.medium,
      colorText: colorCoconut
    },
    large: {
      ...amountTheme.headline.large,
      colorText: colorCoconut
    }
  },
  icon: {
    brandText: {
      colorIcon: colorCoconut,
    },
    brand: {
      colorIcon: colorBlackberry70,
    },
    link: {
      colorIcon: colorBlackberry70,
    },
    grey: {
      colorIcon: colorBlackberry60,
    },
    secondary: {
      colorIcon: colorAvocado,
    },
    tertiary: {
      colorIcon: colorBlackberry45,
    },
    error: {
      colorIcon: colorPomegranate70,
    },
  },
  input: {
    ...amountTheme.input,
    colorFocus: colorCoconut,
    colorBackground: 'transparent',
    colorPlaceholder: colorBlackberry45,
    colorTextAreaBackground: colorBlackberry,
    colorBorder: colorBlackberry45,
    colorTextAreaBorder: colorBlackberry45,
    // tslint:disable-next-line:max-line-length
    selectInputBackgroundSvgFocused: `"data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIC03IDE3IDE3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0xNiAxLTcuNSA3LTcuNS03IiBmaWxsPSJub25lIiBzdHJva2U9IiNmMmYyZjIiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPgo="`,
  },
  label: {
    ...amountTheme.label,
    formLabelColor: colorBlackberry45,
  },
  link: {
    colorLink: colorCoconut,
    colorLinkIcon: colorCoconut,
    colorLinkHover: colorAvocado,
  },
  modal: {
    ...amountTheme.modal,
    colorText: colorCoconut,
    colorHeadlineText: colorCoconut,
    colorDrawerBorder: colorBlackberry70,
    colorDrawerHover: colorAvocado,
    colorDrawerBackgroundHover: 'transparent',
  },
  notification: {
    ...amountTheme.notification,
    colorHover: colorAvocado
  },
  pill: {
    ...amountTheme.pill,
    alert: {
      ...amountTheme.pill.alert,
      colorText: colorBlackberry
    },
    success: {
      ...amountTheme.pill.success,
      colorText: colorBlackberry,
    },
    primary: {
      ...amountTheme.pill.primary,
      colorText: colorBlackberry,
    },
    secondary: {
      ...amountTheme.pill.secondary,
      colorText: colorCoconut,
    },
    warning: {
      ...amountTheme.pill.warning,
      colorText: colorBlackberry
    },
    default: {
      ...amountTheme.pill.default,
      colorText: colorBlackberry,
    },
  },
  radio: {
    ...amountTheme.radio,
    boxShadow: 'transparent',
    boxShadowHover: 'transparent',
    colorBorder: colorBlackberry05,
    colorBorderHover: colorAvocado,
    colorBorderChecked: colorAvocado,
    colorText: colorBlackberry05,
    colorTextAlert: colorPomegranate70,
    colorTextHover: colorAvocado,
    colorTextChecked: colorBlackberry,
    colorBackground: colorBlackberry,
    colorBackgroundHover: colorBlackberry,
    colorBackgroundChecked: '#63C698',
    focus: {
      outline: { color: '#2178C0', offset: '2px' }
    },
    disabled: {
      border: { color: colorBlackberry70, size: '2px' },
      colorBackground: '#264856'
    },
    disabledChecked: {
      colorBackground: colorBlackberry70,
      border: { size: '2px', color: colorBlackberry70 },
      labelColor: colorBlackberry20
    },
    alertChecked: {
      colorText: colorPomegranate70,
      colorBackground: 'transparent',
      border: { size: '2px', color: colorPomegranate70 }
    }
  },
  radioCard: {
    ...amountTheme.radioCard,
    colorText: colorCoconut,
    colorTextHover: colorAvocado,
  },
  radioInput: {
    ...amountTheme.radioInput,
    colorInner: colorCoconut,
    colorBorder: colorCoconut,
    colorRadioLabelBackground: 'transparent',
  },
  spinner: {
    colorBackground: colorBlackberry70,
    colorSegment: colorCoconut
  },
  table: {
    ...amountTheme.table,
    colorDivider: 'rgba(242, 242, 242, 0.5)',
  },
  taskCard: {
    ...amountTheme.taskCard,
    colorBorder: colorCoconut,
    colorText: colorCoconut,
    colorIcon: colorCoconut,
    colorCtaIcon: colorCoconut,
    colorSubhead: colorCoconut,
    colorInReviewBorder: colorCoconut,
    colorCompleteText: colorBlackberry60,
  },
  text: {
    ...amountTheme.text,
    colorText: colorCoconut,
    colorCaption: colorBlackberry45,
  },
  upload: {
    ...amountTheme.upload,
    colorBackground: 'rgba(2,42,58,0.95)',
    colorBorder: 'rgba(123,239,178,0.8)',
    colorActiveBackground: 'rgba(2,42,58,0.95)',
    colorActiveBorder: 'rgba(123,239,178,0.8)',
    colorText: colorCoconut
  },
  verifications: {
    mastHeadlineColor: colorCoconut,
  },
  // themeTwo should be removed once themeTwo replaces current theme
  themeTwo: { ...amountDarkThemeTwo },
};

export default theme;
